import type { SimpleGridProps as MantineSimpleGridProps } from '@mantine/core';
import { SimpleGrid as MantineSimpleGrid } from '@mantine/core';

type SimpleGridProps = MantineSimpleGridProps;

export const SimpleGrid = (props: SimpleGridProps) => {
  return <MantineSimpleGrid {...props} />;
};
